<template>
  <div
    class="py-4 container-fluid min-vh-100 forum-page"
    :class="isDarkMode ? 'forum-page-dark' : 'bg-light-moniex'"
    :style="isDarkMode
      ? 'background: #1E293B !important; min-height: 100vh;'
      : 'background: #f8f9fa; min-height: 100vh;'"
  >
    <div
      class="forum-hero-banner mb-3"
      :style="isDarkMode
        ? 'background: #0F172A !important; border: 1px solid #334155 !important; box-shadow: none !important; color: #E2E8F0 !important; border-radius: 0.65rem !important;'
        : 'border-radius: 0.65rem !important;'"
    >
      <div class="forum-hero-content">
        <h1
          :style="isDarkMode
            ? 'color: #FF8A4C !important; font-weight: 800 !important; font-size: 1.5rem !important; letter-spacing: -0.02em;'
            : 'font-weight: 800 !important; font-size: 1.5rem !important; letter-spacing: -0.02em;'"
        >Fórum</h1>
        <p :style="isDarkMode ? 'color: #CBD5E1 !important; opacity: 1;' : ''">
          Posledních 20 příspěvků z her, akcií a výher. Klikni a otevři vlákno.
        </p>
      </div>
    </div>

    <div class="row align-items-start">
      <div class="col-12 col-lg-8 mb-4">
        <div
          class="border-0 shadow-sm rounded-4 overflow-hidden p-3"
          :style="surfaceStyle"
        >
          <forum-table :rows="posts" />
        </div>
      </div>
      <div class="col-12 col-lg-4 mb-4">
        <ActiveGamesSidebar />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import dataService from "@/services/dataService.js";
import ForumTable from "./components/custom/tables/ForumTable.vue";
import ActiveGamesSidebar from "./components/custom/ActiveGamesSidebar.vue";

const store = useStore();
const isDarkMode = computed(() => !!store.state.isDarkMode);
const posts = ref([]);

const surfaceStyle = computed(() => {
  if (store.state.isDarkMode) {
    return "background: #0F172A !important; background-color: #0F172A !important; border: 1px solid #334155 !important; border-radius: 0.65rem !important;";
  }
  return "background: #ffffff; border: 1px solid transparent; border-radius: 0.65rem !important;";
});

const fetchLastChat = async () => {
  const data = await dataService.GetLastChat();
  posts.value = Array.isArray(data) ? data : [];
};

fetchLastChat();
</script>

<style scoped>
.forum-hero-banner {
  background: linear-gradient(135deg, #FFE8D6 0%, #FFD6BB 100%);
  border: 1px solid #FEC88F;
  border-radius: 0.65rem;
  padding: 16px 24px;
  color: #0F172A;
  box-shadow: none;
}

.forum-hero-content h1 {
  font-family: 'Ubuntu Sans', Ubuntu, sans-serif;
  font-size: 1.5rem;
  font-weight: 800 !important;
  letter-spacing: -0.02em;
  line-height: 1.2;
  margin-bottom: 4px;
  color: #C2460F;
}

.forum-hero-content p {
  margin-bottom: 0;
  opacity: 1;
  font-size: 0.88rem;
  line-height: 1.35;
  color: #56647A;
}

.bg-light-moniex {
  background-color: #f8f9fa;
}

.forum-page-dark :deep(.vgt-inner-wrap),
.forum-page-dark :deep(.vgt-responsive),
.forum-page-dark :deep(.vgt-wrap) {
  background: transparent !important;
  box-shadow: none !important;
}

.forum-page-dark :deep(.vgt-table) {
  background: transparent !important;
  color: #E2E8F0 !important;
  border: none !important;
}

.forum-page-dark :deep(.vgt-table th) {
  background: #1E293B !important;
  color: #94A3B8 !important;
  border-color: #334155 !important;
}

.forum-page-dark :deep(.vgt-table td) {
  background: transparent !important;
  color: #E2E8F0 !important;
  border-color: #334155 !important;
}

.forum-page :deep(.vgt-table tbody tr:last-child td),
.forum-page-dark :deep(.vgt-table tbody tr:last-child td) {
  border-bottom: none !important;
}

.forum-page-dark :deep(.vgt-table tbody tr:hover),
.forum-page-dark :deep(.vgt-table tr.clickable:hover) {
  background-color: #1E293B !important;
  cursor: pointer;
}

.forum-page :deep(.vgt-table tbody tr),
.forum-page :deep(.vgt-table tr.clickable) {
  cursor: pointer;
}

.forum-page-dark :deep(.text-dark) {
  color: #E2E8F0 !important;
}
</style>
